import { Questionnaire, QuestionnaireObjectType } from './Questionnaires';

export enum CardType {
    Saver,
    Waster,
    FossilFuel,
    Renewable,
    Energy,
}
export const CleanTypes: CardType[] = [CardType.Saver, CardType.Renewable, CardType.Energy];
export const DirtyTypes: CardType[] = [CardType.Waster, CardType.FossilFuel];

export class Card {
    CardId: string;
    Type: CardType;
    // Title: string;
    Description: string;
    CardValue: number;
    useOnSelf: boolean;
    IsClean: boolean;
    ImageUrl: string;
    Questionnaire: Questionnaire | null;
    constructor(data: any) {
        this.CardId = data.CardId;
        this.ImageUrl = data.ImageUrl;
        this.Type = data.Type;
        this.IsClean = !data.IsClean ? CleanTypes.includes(this.Type) : data.IsClean;
        this.Description = data.Description;
        this.CardValue = data.CardValue;
        this.useOnSelf = !data.useOnSelf ? CleanTypes.includes(data.Type) : data.useOnSelf;
        // this.Title = data.Title ? data.Title : `Add ${this.CardValue}kW of ${this.IsClean ? 'CLEAN' : 'DIRTY'} energy to ${this.useOnSelf ? 'YOUR' : 'OPPONENTS'} grid`;
        this.Questionnaire = data.Questionnaire;
    }
}

export type CardObjectType = {
    CardId: string;
    Type: CardType;
    // Title: string;
    Description: string;
    CardValue: number;
    useOnSelf: boolean;
    IsClean: boolean;
    ImageUrl: string;
    Questionnaire: QuestionnaireObjectType | null;
};
